import t from"react";var o=t.createContext({orientation:"horizontal"}),r=function(){return t.useContext(o)};export{o as GalleryNextThumbnailsContext,r as useGalleryNextThumbnailsContext};
